import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import PillButton from '../buttons/Pill';
import MultiWolf from '../icons/2025/MultiWolf';
// import LouveIcon from '../icons/Louve';
import Image from './Image';

import styles from '../../../styles/partials/card-visual.module.scss';

const propTypes = {
    color: PropTypes.oneOf(['green', 'orange', 'yellow', 'black']),
    image: AppPropTypes.image,
    tagComponents: PropTypes.node,
    tagsPosition: PropTypes.oneOf(['left', 'right']),
    pillContent: PropTypes.node,
    pillPosition: PropTypes.oneOf(['left', 'right']),
    placeholderIndex: PropTypes.number,
    className: PropTypes.string,
    imageClassName: PropTypes.string,
    imageWrapClassName: PropTypes.string,
};

const defaultProps = {
    color: null,
    image: null,
    tagComponents: null,
    tagsPosition: 'left',
    pillContent: null,
    pillPosition: 'right',
    placeholderIndex: null,
    className: null,
    imageClassName: null,
    imageWrapClassName: null,
};

const CardVisual = ({
    color,
    image,
    tagComponents,
    tagsPosition,
    pillContent,
    pillPosition,
    placeholderIndex,
    className,
    imageClassName,
    imageWrapClassName,
}) => {
    const { url: imageUrl } = image || {};
    const placeholder = useMemo(() => {
        if (placeholderIndex !== null) {
            return (
                <MultiWolf
                    className={classNames([styles.placeholder, styles.yellowPlaceholder])}
                    type={(placeholderIndex % 5) + 1}
                />
            );
        }
        switch (color) {
            case 'green':
                return <MultiWolf type={1} className={styles.placeholder} />;
            case 'black':
                return <MultiWolf type={2} className={styles.placeholder} />;
            case 'orange':
                return <MultiWolf type={3} className={styles.placeholder} />;
            case 'yellow':
                return <MultiWolf type={4} className={styles.placeholder} />;
            default:
                return <MultiWolf type={5} className={styles.placeholder} />;
        }
    }, [color, placeholderIndex]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles[color]]: color,
                    [className]: className !== null,
                },
            ])}
        >
            {pillContent !== null ? (
                <PillButton
                    className={classNames([
                        styles.pill,
                        {
                            [styles.pillLeft]: pillPosition === 'left',
                            [styles.pillRight]: pillPosition === 'right',
                        },
                    ])}
                >
                    {pillContent}
                </PillButton>
            ) : null}
            {tagComponents !== null ? (
                <div
                    className={classNames([
                        styles.tags,
                        {
                            [styles.tagsLeft]: tagsPosition === 'left',
                            [styles.tagsRight]: tagsPosition === 'right',
                        },
                    ])}
                >
                    {tagComponents}
                </div>
            ) : null}
            {image !== null && imageUrl !== null ? (
                <Image
                    className={classNames([
                        styles.imageWrap,
                        {
                            [imageWrapClassName]: imageWrapClassName !== null,
                        },
                    ])}
                    imageClassName={classNames([
                        styles.image,
                        { [imageClassName]: imageClassName !== null },
                    ])}
                    media={image}
                    fit
                    cover
                />
            ) : (
                placeholder
            )}
        </div>
    );
};

CardVisual.propTypes = propTypes;
CardVisual.defaultProps = defaultProps;

export default CardVisual;
